import { ArrowRight, ShieldCheck } from "lucide-react";
import { SITE } from "@/lib/site";

const words = [
  { text: "Precio.", style: { left: "8%", top: "77%" } },
  { text: "Stock.", style: { right: "8%", top: "77%" } },
  { text: "Trazabilidad.", style: { left: "50%", bottom: "15%", transform: "translateX(-50%)" } },
];

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 md:pt-32 pb-16 md:pb-24">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="relative rounded-[36px] md:rounded-[44px] overflow-hidden card-glass p-6 md:p-14 min-h-[640px] md:min-h-[720px]">
          {/* Aurora orbs and rings */}
          <div className="pointer-events-none absolute inset-0">
            <div className="aurora-orb" style={{ width: "780px", height: "780px", left: "50%", top: "58%", transform: "translate(-50%, -50%)" }} />
            <div className="aurora-ring" style={{ width: "900px", height: "900px", left: "50%", top: "58%", transform: "translate(-50%, -50%)" }} />
            <div className="aurora-ring" style={{ width: "1080px", height: "1080px", left: "50%", top: "58%", transform: "translate(-50%, -50%)", opacity: 0.55 }} />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[70%] h-24 bg-gradient-to-b from-white/70 to-transparent blur-2xl opacity-70" />
          </div>

          {/* Top chip */}
          <div className="relative flex justify-center mb-10 md:mb-14">
            <span className="chip" data-testid="hero-chip-isp">
              <span className="dot" /> Programa Distribución · Solo clínicas ≥ 100 u/mes
            </span>
          </div>

          {/* Headline */}
          <div className="relative text-center">
            <h1
              className="font-display text-[38px] sm:text-5xl md:text-6xl lg:text-[76px] font-bold leading-[1.02] tracking-[-0.03em] text-[#0B0B14] max-w-4xl mx-auto"
            >
              Compras 100+ fillers al mes.
              <br className="hidden md:block" /> Estás pagando <span className="text-[#5A48C9]">40%–80% de más.</span>
            </h1>

            <p
              className="mt-6 md:mt-8 text-base md:text-lg text-[#3A3A48] max-w-xl mx-auto leading-relaxed"
            >
              Las clínicas de mayor volumen en Chile dejaron de comprar a revendedores.
              Nos compran a nosotros a precio de fábrica en Korea — con factura,
              certificado ISP por lote y stock permanente en Santiago.
            </p>

            <div
              className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3"
            >
              <a
                data-testid="hero-cta-primary"
                href="#contacto"
                className="btn-pill btn-primary shine text-[15px] px-6 py-3.5"
              >
                Solicitar evaluación de precio
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                data-testid="hero-cta-brochure"
                href={SITE.brochureUrl}
                target="_blank"
                rel="noreferrer"
                className="btn-pill btn-ghost text-[15px] px-6 py-3.5"
              >
                Ver ficha técnica AEGENBIO
              </a>
            </div>

            <p className="mt-5 text-xs md:text-[13px] text-[#5A48C9] font-semibold">
              Evaluación confidencial · Sin costo · Respuesta en menos de 24 hrs hábiles
            </p>
          </div>

          {/* Scattered orb words */}
          {words.map((w) => (
            <p
              key={w.text}
              style={w.style}
              className="absolute font-display text-2xl md:text-3xl lg:text-4xl font-bold text-[#0B0B14] tracking-tight hidden sm:block whitespace-nowrap"
            >
              {w.text}
            </p>
          ))}

          {/* Bottom mini-trust bar */}
          <div className="relative mt-16 md:mt-24 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] md:text-xs font-semibold uppercase tracking-widest text-[#5A48C9]">
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheck className="w-3.5 h-3.5" /> ISP Chile · Dispositivo Médico
            </span>
            <span>·</span>
            <span>KGMP · ISO 13485</span>
            <span>·</span>
            <span>Distribuidor autorizado AEGENBIO</span>
          </div>
        </div>
      </div>
    </section>
  );
}
